module.exports = __webpack_public_path__ + "static/media/message.e793fb2e.svg";